module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "MD",
  "DDS",
  "PhD",
  "DVM"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/name/suffix.js
 ** module id = 471
 ** module chunks = 0
 **/